

























































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Action, namespace, State } from 'vuex-class';
import { ToastProgrammatic as Toast } from 'buefy';
import { mixins } from 'vue-class-component';
import StrategyList from './StrategyList.vue';
import BasePaginatorHoc from '../../../components/base/BasePaginatorHoc.vue';
import {
  CreateGripStrategyBase,
  CreateGripStrategyPayload,
  GetStrategiesPayload,
  GripStrategy,
  GripStrategyDTO,
  UpdateGripStrategyBase,
  UpdateGripStrategyPayload,
} from '../../../store/types/grip.types';
import StrategyModal from './StrategyModal.vue';
import {
  ApiState,
  Pagination,
  PaginatorDto,
} from '../../../store/types/general.types';
import { Debounce } from '../../../jbi-shared/util/debounce.vue-decorator';
import BaseLoading from '../../../components/base/BaseLoading.vue';
import {
  isDifferentDeep,
  isTruthy,
} from '../../../jbi-shared/util/watcher.vue-decorator';
import { showUnsavedChangesDialog } from '@/utils/dialog.util';
import DeleteModalBox from '@/components/DeleteModalBox.vue';
import GripSettingsModalManagerMixin from '@/views/Grip/components/grip-settings-modal-manager.mixin';

@Component({
  components: { BaseLoading, BasePaginatorHoc, StrategyList, StrategyModal },
})
export default class StrategySettings extends mixins(
  GripSettingsModalManagerMixin,
) {
  public entityName: string = 'Strategy';
  public entityIdKey: string = 'strategyId';

  @Action('projects/getGripStrategies')
  public getGripStrategies!: (payload: {
    projectId: number;
    params: GetStrategiesPayload;
  }) => void;

  @State((state) => state.projects.gripStrategies)
  public gripStrategies!: Pagination<GripStrategy>;

  @State((state) => state.projects.apiState.getGripStrategies)
  public getGripStrategiesApiState!: ApiState;

  @Action('projects/createGripStrategy')
  public createGripStrategy!: (payload: CreateGripStrategyPayload) => void;

  @State((state) => state.projects.apiState.createGripStrategy)
  public createGripStrategyApiState!: ApiState;

  @Action('projects/updateGripStrategy')
  public updateGripStrategy!: (payload: UpdateGripStrategyPayload) => void;

  @State((state) => state.projects.apiState.updateGripStrategy)
  public updateGripStrategyApiState!: ApiState;

  @Action('projects/deleteGripStrategy')
  public deleteGripStrategy!: (payload: {
    projectId: number;
    strategyId: number;
  }) => void;

  @State((state) => state.projects.apiState.deleteGripStrategy)
  public deleteGripStrategyApiState!: ApiState;

  public getAction = this.getGripStrategies;
  public deleteAction = this.deleteGripStrategy;

  get getApiState(): ApiState {
    return this.getGripStrategiesApiState;
  }
  get createApiState(): ApiState {
    return this.createGripStrategyApiState;
  }
  get updateApiState(): ApiState {
    return this.updateGripStrategyApiState;
  }
  get deleteApiState(): ApiState {
    return this.deleteGripStrategyApiState;
  }

  get StrategyList() {
    return StrategyList;
  }

  get getGripStrategyList(): GripStrategy[] {
    return this.gripStrategies.items || [];
  }

  get totalCount(): number {
    return this.gripStrategies.totalItems || 0;
  }

  public handleStrategyCreate(gripStrategy: CreateGripStrategyBase) {
    this.createGripStrategy({
      ...gripStrategy,
      projectId: this.projectId,
    });
  }

  /**
   * Handle updating a strategy.
   *
   * If the ID of the data to update matches the currently edited strategy ID,
   * create an update payload and call updateGripStrategy.
   * If the update payload contains no actual changes, just close the modal.
   * If the IDs do not match or the ID is missing, log an error and close the modal.
   * @param gripStrategyUpdateData - The data to update the strategy with.
   */
  public handleStrategyUpdate(
    gripStrategyUpdateData: UpdateGripStrategyBase & { id: number },
  ): void {
    if (
      this.editingEntityId !== null &&
      this.editingEntityId === gripStrategyUpdateData.id
    ) {
      const { id, ...changesToApply } = gripStrategyUpdateData;
      if (Object.keys(changesToApply).length > 0) {
        const payload: UpdateGripStrategyPayload = {
          ...gripStrategyUpdateData, // contains id and changes
          id: this.editingEntityId,
          projectId: this.projectId,
        };
        this.updateGripStrategy(payload);
        // Watcher for updateGripStrategyApiState.success will handle modal close
      } else {
        // No actual changes, just close the modal
      }
    } else {
      this.closeModal();
    }
  }
}
